export default __webpack_public_path__ + "static/media/WF3.4357148c.png";